module.exports = __webpack_public_path__ + "img/34.afc10152.jpg";